import $ from 'jquery';
import Settings from 'source/lib/settings_model';

const mobile = function mobile() {
    const docElement = document.documentElement;
    const mod = 'modernizr';
    const injectElementWithStyles = function injectElementWithStyles(
        rule,
        callback,
        nodes,
        testnames
    ) {
        let docOverflow;
        const div = document.createElement('div');
        const body = document.body;
        const fakeBody = body || document.createElement('body');

        if (parseInt(nodes, 10)) {
            let i = nodes;
            while (i) {
                i -= 1;
                const node = document.createElement('div');
                node.id = testnames ? testnames[i] : mod + (i + 1);
                div.appendChild(node);
            }
        }
        const style = `&#173;<style id="s${mod}">${rule}</style>`;
        div.id = mod;
        (body ? div : fakeBody).innerHTML += style;
        fakeBody.appendChild(div);
        if (!body) {
            fakeBody.style.background = '';
            fakeBody.style.overflow = 'hidden';
            docOverflow = docElement.style.overflow;
            docElement.style.overflow = 'hidden';
            docElement.appendChild(fakeBody);
        }
        const ret = callback(div, rule);
        if (!body) {
            fakeBody.parentNode.removeChild(fakeBody);
            docElement.style.overflow = docOverflow;
        } else {
            div.parentNode.removeChild(div);
        }
        return !!ret;
    };
    const testMediaQuery = function testMediaQuery(mq) {
        const matchMedia = window.matchMedia || window.msMatchMedia;
        if (matchMedia) {
            return matchMedia(mq).matches;
        }
        let bool;
        injectElementWithStyles(`@media ${mq} { #${mod} { position: absolute; } }`, (node) => {
            const computedStyle = getComputedStyle(node, null);
            const style = window.getComputedStyle ? computedStyle : node.currentStyle;
            bool = style.position === 'absolute';
        });
        return bool;
    };

    const Application = window.Application;
    let settings = Settings.get('Mobile');
    const currentAgent = navigator.userAgent;

    if (!settings) {
        settings = {};
        Settings.set({ Mobile: settings });
    }

    // TODO: update user agent lists
    const smallListOfUserAgents = [
        'up.browser', 'up.link', 'mmp', 'symbian', 'smartphone', 'midp',
        'wap', 'phone', 'windows ce', 'pda', 'mobile', 'mini', 'palm',
        'netfront', 'opera mobi', 'android', 'xoom', 'sch-i800',
        'playbook', 'tablet', 'kindle', 'mobile safari', 'wp7'
    ];
    const smallListOfUserAgentsRegexp = new RegExp(`(?:${smallListOfUserAgents.join('|')})`, 'i');

    const smallListOfUserAgentsExcludes = [
        'ipad'
    ];
    const smallListOfUserAgentsExcludesRegexp = new RegExp(
        `(?:${smallListOfUserAgentsExcludes.join('|')})`,
        'i'
    );

    const bigListOfUserAgents = [
        'w3c ', 'acs-', 'alav', 'alca', 'amoi', 'audi',
        'avan', 'benq', 'bird', 'blac', 'blaz', 'brew',
        'cell', 'cldc', 'cmd-', 'dang', 'doco', 'eric',
        'hipt', 'inno', 'ipaq', 'java', 'jigs', 'kddi',
        'keji', 'leno', 'lg-c', 'lg-d', 'lg-g', 'lge-',
        'maui', 'maxo', 'midp', 'mits', 'mmef', 'mobi',
        'mot-', 'moto', 'mwbp', 'nec-', 'newt', 'noki',
        'xda', 'palm', 'pana', 'pant', 'phil', 'play',
        'port', 'prox', 'qwap', 'sage', 'sams', 'sany',
        'sch-', 'sec-', 'send', 'seri', 'sgh-', 'shar',
        'sie-', 'siem', 'smal', 'smar', 'sony', 'sph-',
        'symb', 't-mo', 'teli', 'tim-', 'tosh', 'tsm-',
        'upg1', 'upsi', 'vk-v', 'voda', 'wap-', 'wapa',
        'wapi', 'wapp', 'wapr', 'webc', 'winw', 'winw',
        'xda-'
    ];
    const bigListOfUserAgentsRegexp = new RegExp(`^(?:${bigListOfUserAgents.join('|')})`, 'i');
    const maxMobileWidthMediaQuery = 'all and (max-width: 799px)';

    let isMobile = smallListOfUserAgentsRegexp.test(currentAgent);
    if (!isMobile) {
        isMobile = bigListOfUserAgentsRegexp.test(currentAgent);
    }
    if (isMobile) {
        isMobile = !smallListOfUserAgentsExcludesRegexp.test(currentAgent);
    }
    if (isMobile) {
        isMobile = testMediaQuery(maxMobileWidthMediaQuery);
    }

    const forceDesktopCookieName = Settings.get('General.MobileBrowserForceDesktopCookieName',
                                                'wgn_mobile_browser_force_desktop');
    const checkForceDesktopCookie = () => $.cookie(forceDesktopCookieName);
    const toogleForceDesktopCookie = function toogleForceDesktopCookie() {
        const value = checkForceDesktopCookie() ? null : true;
        const options = { path: '/' };

        $.cookie(forceDesktopCookieName, value, options);
    };
    const forceDesktop = checkForceDesktopCookie();
    const useMobile = isMobile && !forceDesktop;

    settings.isMobile = isMobile;
    settings.forceDesktop = forceDesktop;
    settings.useMobile = useMobile;

    Settings.set({ Mobile: settings });

    Application.on('mobile-browser-force-desktop', () => {
        toogleForceDesktopCookie();
        window.location.href = window.location.href;
    });
    Application.on('mobile-browser-detected-onload', (options) => {
        if (options.detected && options.forceDesktop) {
            $('.js-mobile-browser-force-desktop-item').show();
        }
    });

    Application.trigger('mobile-browser-detected', {
        detected: isMobile,
        forceDesktop,
        useMobile
    });

    $(() => Application.trigger('mobile-browser-detected-onload', {
        detected: isMobile,
        forceDesktop,
        useMobile
    }));

    $(() => {
        $('.js-mobile-browser-force-desktop-link').on('click', () => {
            Application.trigger('mobile-browser-force-desktop');
        });
    });
};

export default mobile;



// WEBPACK FOOTER //
// ./static-source/js/mobile.js